const banners = {
    1: {
        name: 'Swift 1',
        title: 'до <b>10</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    2: {
        name: 'Swift 1',
        title: '<b>14”</b> Full HD IPS',
        desc: 'Дисплей',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    3: {
        name: 'Swift 1',
        title: '<b>10</b> Windows',
        desc: 'Домашняя',
        img: '/static/img/parts/swift/rek-bg.png',
        link: '/product/swift_1',
        className: 'swift_1'
    },
    4: {
        name: 'Spin 1',
        title: '<b>11,6"</b> FHD IPS',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/spin_1.png',
        link: '/product/spin_1',
        className: 'spin_1'
    },
    5: {
        name: 'Spin 1',
        title: '<b>4</b> положения',
        desc: 'для комфортной работы в любых условиях',
        img: '/static/img/parts/swift/spin_1.png',
        link: '/product/spin_1',
        className: 'spin_1'
    },
    6: {
        name: 'Swift 3',
        title: '<b>12</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/swift_3.png',
        link: '/product/swift_3',
        className: 'swift_3'
    },
    7: {
        name: 'Swift 3',
        title: '<b>14"</b> FULL HD IPS',
        desc: 'дисплей в корпусе 13,3’’',
        img: '/static/img/parts/swift/swift_3.png',
        link: '/product/swift_3',
        className: 'swift_3'
    },
    8: {
        name: 'Swift 5',
        title: '<b>14"</b> FULL HD IPS',
        desc: 'сенсорный дисплей в корпусе 13,3’’',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5'
    },
    9: {
        name: 'Swift 5',
        title: '<b>8</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5 center-swift'
    },
    10: {
        name: 'Swift 5',
        title: '<b>970</b> грамм',
        desc: 'вес ноутбука',
        img: '/static/img/parts/swift/swift_5.png',
        link: '/product/swift_5',
        className: 'swift_5'
    },
    11: {
        name: 'Spin 5',
        title: '<b>13</b> часов',
        desc: 'автономной работы',
        img: '/static/img/parts/swift/spin_5.png',
        link: '/product/spin_5',
        className: 'spin_5'
    },
    12: {
        name: 'Spin 5',
        title: '<b>13,3"</b> FHD IPS',
        desc: 'сенсорный дисплей',
        img: '/static/img/parts/swift/spin_5.png',
        link: '/product/spin_5',
        className: 'spin_5'
    }
}

export default banners;


// WEBPACK FOOTER //
// ./src/configs/banners.js